import { createApp } from "vue"
import { createPinia } from "pinia"
import router from "./router"
import "./style.css"
import App from "./App.vue"
import * as Sentry from "@sentry/vue"
import { i18n } from "./i18n"

const app = createApp(App)

if (import.meta.env.PROD || import.meta.env.MODE === "production") {
  Sentry.init({
    app,
    dsn: "https://0fcd5defb0364db45f690b35fd215cc2@o4505193555623936.ingest.us.sentry.io/4510364810674176",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    enableLogs: true,
    release: "dinecloud-manager@" + import.meta.env?.VITE_CF_PAGES_COMMIT_SHA,
    integrations: [
      // send console.log, console.warn, and console.error calls as logs to Sentry
      Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
    ],
    // Add Tracing by setting tracesSampleRate
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    // Set sampling rate for profiling
    // This is relative to tracesSampleRate
    profilesSampleRate: 1.0,
  })
}

app.use(createPinia())
app.use(router)
app.use(i18n)

app.mount("#app")

// Register service worker for PWA push notifications
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        // eslint-disable-next-line no-console
        console.log("✅ Service Worker registered:", registration.scope)
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.warn("⚠️ Service Worker registration failed:", error)
      })
  })
}
